import axios from "axios";

export const getIOPortsAPI = async () => {
  let response = await axios({
    url: `/api/v2/io/ports`,
    method: "GET"
  });
  if (response.data && response.data.io_ports) {
    return response.data.io_ports;
  }
};
